import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { Reservation } from '@app/_components/reservation';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { SharedService } from './../_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class ReservationService {

	orderStatuses: any[] =
		[
			{ value: "", name: "" },
			{ name: 'Quote', value: 'QO' },
			{ name: 'Open', value: 'OP' },
			{ name: 'Closed', value: 'OC' },
			{ name: 'Cancelled', value: 'OX' },
		];

	listingTypes = [
		{ value: 1, name: 'Short Term Rental' },
		{ value: 2, name: 'Composite' },
		{ value: 3, name: 'Hotel Room Type' }
	];

	reservationTypes: any[] =
		[

		    { value: 3, name:  'GUEST', channel : 'admin' , reservationStatus : 'OP' },
			{ value: 14, name: 'HOLD', channel: 'admin', reservationStatus: 'QH' },
			{ value: 16, name: 'TRAVEL AGENT', channel: 'admin', reservationStatus: 'OP' },
			{ value: 1, name: 'OWNER', channel: 'admin_owner_booking', reservationStatus: 'OO' },
			{ value: 2, name: 'OWNER GUEST', channel: 'admin_owner_booking', reservationStatus: 'OG' },
			{ value: 15, name: 'OWNER GUEST PAID', channel: 'admin_owner_booking', reservationStatus: 'OG' },
			{ value: 0, name: '-------------------', channel: 'admin', reservationStatus: '' },
			{ value: 6, name: 'OWNER ARRIVAL PREP', channel: 'admin_maintenance_booking', reservationStatus: 'NA' },
			{ value: 12, name: 'OWNER REQUESTED BLOCK', channel: 'admin_maintenance_booking', reservationStatus: 'NA' },
			{ value: 11, name: 'DELIVERY', channel: 'admin_maintenance_booking', reservationStatus: 'NA' },
			{ value: 5, name: 'HOUSEKEEPING BLOCK', channel: 'admin_maintenance_booking', reservationStatus: 'NA' },
			{ value: 10, name: 'INVENTORY', channel: 'admin_maintenance_booking', reservationStatus: 'NA' },
			{ value: 4, name: 'MAINTENANCE', channel: 'admin_maintenance_booking', reservationStatus: 'NA' },
			{ value: 13, name: 'OFFICE BLOCK', channel: 'admin_maintenance_booking', reservationStatus: 'NA' },
			{ value: 8, name: 'OFFBOARDING', channel: 'admin_maintenance_booking', reservationStatus: 'NA' },
			{ value: 7, name: 'ONBOARDING', channel: 'admin_maintenance_booking', reservationStatus: 'NA' },
			{ value: 9, name: 'PICTURES', channel: 'admin_maintenance_booking', reservationStatus: 'NA' }
		];

	hours: any[] =
		[
			{ value: "", name: "" },
			{ name: '1', value: 1 },
			{ name: '2', value: 2 },
			{ name: '3', value: 3 },
			{ name: '4', value: 4 },
			{ name: '5', value: 5 },
			{ name: '6', value: 6 },
			{ name: '7', value: 7 },
			{ name: '8', value: 8 },
			{ name: '9', value: 9 },
			{ name: '10', value: 10 },
			{ name: '11', value: 11 },
			{ name: '12', value: 12 },
		];

	minutes: any[] =
		[
			{ value: "", name: "" },
			{ name: "00", value: "00" },
			{ name: "05", value: "05" },
			{ name: "05", value: "05" },
			{ name: "15", value: "15" },
			{ name: "20", value: "20" },
			{ name: "25", value: "25" },
			{ name: "30", value: "30" },
			{ name: "35", value: "35" },
			{ name: "40", value: "40" },
			{ name: "45", value: "45" },
			{ name: "50", value: "50" },
			{ name: "55", value: "55" },
		];

	airlines: any[] = [
		{ value: "", name: "" },
		{ value: "AC", name: "Air Canada" },
		{ value: "AS", name: "Alaska" },
		{ value: "AA", name: "American" },
		{ value: "US", name: "US Airways" },
		{ value: "CO", name: "Continental" },
		{ value: "DL", name: "Delta" },
		{ value: "GO", name: "go!" },
		{ value: "HA", name: "Hawaiian" },
		{ value: "WP", name: "Island Air" },
		{ value: "MW", name: "Mokulele Express" },
		{ value: "LW", name: "Pacific Wings" },
		{ value: "SW", name: "Southwest" },
		{ value: "UA", name: "United" },
		{ value: "VX", name: "Virgin America" },
		{ value: "WS", name: "West Jet" },
	]

	housekeepingTypes: any[] = [
		{ value: "", name: "" },
		{ value: 1, name: "Interim" },
		{ value: 2, name: "Checkout" },
		{ value: 3, name: "Linens-only" },
	]

	workOrderTypes: any[] = [
		{ value: "", name: "" },
		{ value: 1, name: "Housekeeping" },
		{ value: 2, name: "Maintenance" },
	]

	workOrderStatuses: any[] = [
		{ value: "", name: "" },
		{ value: 1, name: "Open" },
		{ value: 2, name: "Complete" },
		{ value: 3, name: "Canceled" },
		{ value: 4, name: "Scheduled Maintenance" },
	]

	amPm: any[] =
		[
			{ value: "", name: "" },
			{ name: "AM", value: "0" },
			{ name: "PM", value: "1" },
		]

	numAdults: any[] =
		[
			{ value: 1, name: '1' },
			{ value: 2, name: '2' },
			{ value: 3, name: '3' },
			{ value: 4, name: '4' },
			{ value: 5, name: '5' },
			{ value: 6, name: '6' },
			{ value: 7, name: '7' },
			{ value: 8, name: '8' },
			{ value: 9, name: '9' },
			{ value: 10, name: '10' },
			{ value: 11, name: '11' },
			{ value: 12, name: '12' },
			{ value: 13, name: '13' },
			{ value: 14, name: '14' },
			{ value: 15, name: '15' },
			{ value: 16, name: '16' },
		];

	children: any[] =
		[
			{ value: 0, name: '0' },
			{ value: 1, name: '1' },
			{ value: 2, name: '2' },
			{ value: 3, name: '3' },
			{ value: 4, name: '4' },
			{ value: 5, name: '5' },
			{ value: 6, name: '6' },
			{ value: 7, name: '7' },
			{ value: 8, name: '8' },
			{ value: 9, name: '9' },
			{ value: 10, name: '10' },
			{ value: 11, name: '11' },
			{ value: 12, name: '12' },
			{ value: 13, name: '13' },
			{ value: 14, name: '14' },
			{ value: 15, name: '15' },
			{ value: 16, name: '16' },
		];

	referralSources: any[] =
		[
			{ value: '', name: '' },
			{ value: 14, name: 'AirBnb' },
			{ value: 13, name: 'Booking.com' },
			{ value: 12, name: 'Expedia' },
			{ value: 2, name: 'FlipKey' },
			{ value: 17, name: 'Golfhom' },
			{ value: 3, name: 'Homeaway' },
			{ value: 5, name: 'Guest Referral' },
			{ value: 10, name: 'Family & Friends' },
			{ value: 7, name: 'Google' },
			{ value: 15, name: 'Marriott' },
			{ value: 9, name: 'Owner Referral' },
			{ value: 18, name: 'Realtor' },
			{ value: 6, name: 'Repeat Guest' },
			{ value: 16, name: 'Trip Advisor' },
			{ value: 8, name: 'Unknown' },
			{ value: 1, name: 'VRBO' },
			{ value: 11, name: 'Website' },
			{ value: 19, name: 'Whimstay' },  // added by JPM 10-7-2024
			{ value: 20, name: 'Hopper' },  // added by JPM 10-7-2024
			{ value: 21, name: 'PlumbGuide' }  // added by JPM 10-7-2024
		];

	payEnum: any[] =
		[
			{ value: 0, name: 'Default' },
			{ value: 1, name: 'Guest' },
			{ value: 2, name: 'KBM' },
			{ value: 3, name: 'Homeowner' },
			{ value: 4, name: 'Vendor' },
			{ value: 5, name: 'Travel Agent' },
			{ value: 6, name: 'Rental Car' },
			{ value: 7, name: 'Housekeeping' },
			{ value: 8, name: 'Resort' },
		];

	// reservationStatuses: any[] =
	// 	[
	// 		{ value: 'QO', name: 'Quote - Open' },
	// 		{ value: 'QH', name: 'Quote - On Hold' },
	// 		{ value: 'QE', name: 'Quote - Hold Expired' },
	// 		{ value: 'OP', name: 'Reservation - Confirmed' },
	// 		{ value: 'OC', name: 'Reservation - Closed' },
	// 		{ value: 'PP', name: 'Reservation - Postponed' },
	// 		{ value: 'OX', name: 'Reservation - Cancelled' },
	// 		{ value: 'NA', name: 'Not Available' },
	// 		{ value: 'OO', name: 'Owner Occupied' },
	// 		{ value: 'OG', name: "Owner's Guest Occupied" },
	// 	];

	reservationStatuses: any[] =
		[
			{ name: 'Open', value: 'QO', color: 'lightgreen',fontColor: 'white' },
			{ name: 'Hold', value: 'QH', color: 'yellow',fontColor: 'black' },
			{ name: 'Expired', value: 'QE', color: '#ec5300',fontColor: 'white' },
			{ name: 'Reserved', value: 'OP', color: 'lightgrey',fontColor: 'black' },
			{ name: 'Closed', value: 'OC', color: '#FF7F7F',fontColor: 'white' },
			{ name: 'Postponed', value: 'PP', color: '#ffb09c',fontColor: 'white' },
			{ name: 'Canceled', value: 'OX', color: 'darkred',fontColor: 'white' },
			{ name: 'Maintenance', value: 'NA', color: 'darkgray',fontColor: 'white' },
			{ name: 'Owner Occ', value: 'OO', color: 'hotpink',fontColor: 'white' },
			{ name: 'Owner Guest', value: 'OG', color: 'lightpink',fontColor: 'white' }
		];

	travelOcassions: any[] = [
		{ value: 'anniversary', name: 'Anniversary' },
		{ value: 'annual trip', name: 'Annual trip' },
		{ value: 'babymoon', name: 'Babymoon' },
		{ value: 'birthday', name: 'Birthday' },
		{ value: 'business', name: 'Business' },
		{ value: 'graduation', name: 'Graduation' },
		{ value: 'holiday', name: 'Holiday' },
		{ value: 'honeymoon', name: 'Honeymoon' },
		{ value: 'reunion', name: 'Reunion' },
		{ value: 'wedding', name: 'Wedding' },
	]

	cardExpiryYears: any[] = [
		{ value: '2022', name: '2022' },
		{ value: '2023', name: '2023' },
		{ value: '2024', name: '2024' },
		{ value: '2025', name: '2025' },
		{ value: '2026', name: '2026' },
		{ value: '2027', name: '2027' },
		{ value: '2028', name: '2028' },
		{ value: '2029', name: '2029' },
		{ value: '2030', name: '2030' },
		{ value: '2031', name: '2031' },
		{ value: '2032', name: '2032' },
		{ value: '2033', name: '2033' },
		{ value: '2034', name: '2034' },
		{ value: '2035', name: '2035' },
		{ value: '2036', name: '2036' },
		{ value: '2037', name: '2037' },
		{ value: '2038', name: '2038' },
		{ value: '2039', name: '2039' },
		{ value: '2040', name: '2040' },
		{ value: '2041', name: '2041' },
	]

	cardExpiryMonths: any[] = [
		{ value: '01', name: '01' },
		{ value: '02', name: '02' },
		{ value: '03', name: '03' },
		{ value: '04', name: '04' },
		{ value: '05', name: '05' },
		{ value: '06', name: '06' },
		{ value: '07', name: '07' },
		{ value: '08', name: '08' },
		{ value: '09', name: '09' },
		{ value: '10', name: '10' },
		{ value: '11', name: '11' },
		{ value: '12', name: '12' },
	]

	paymentTypes: any[] = [
		{ value: "CR", name: 'Credit Card' },
		{ value: "AH", name: 'ACH' },
		{ value: "CH", name: 'Check' },
		{ value: "CC", name: 'Certified Check' },
		{ value: "PC", name: 'Personal Check' },
		{ value: "MO", name: 'Money Order' },
		{ value: "PP", name: 'Paypal' },
		{ value: "CA", name: 'Cash' },
		{ value: "CV", name: 'Credit Voucher' },
	]
	// "", "Kaba", "Meet & Greet", "External"

	keyServiceCheckIn: any[] = [
		{ value: "", name: '' },
		{ value: "KK", name: 'Kaba' },
		{ value: "KM", name: 'Meet & Greet' },
		{ value: "KE", name: 'External' },
	]

	paymentCreditCardRequests: any[] = [
		//{ value: "", name: '' },
		{ value: "AC", name: "Charge" },
		/*{ value: "AO", name: "PreAuth" },
		{ value: "CR", name: "Credit" },
		{ value: "VO", name: "Void" },
		{ value: "PC", name: "PA - Charge" },*/
	]

	salesManList: any[] = [
		{ value: "", name: "" },
		{ value: 11, name: "Motto, Joshua" },
		{ value: 36, name: "Brunold, Justin" },
		{ value: 38, name: "Motto, Jacalene" },
		{ value: 3535, name: "Bura, Barbara" },
		{ value: 3666, name: "Brunold, John" },
		{ value: 5313, name: "Brunold, Jill" },
		{ value: 7351, name: "Dizon, Alexis" },
		{ value: 8307, name: "Gardner, Barbara" },
		{ value: 9029, name: "Soukup, Amber" },
		{ value: 10474, name: "Compton, Ronit" },
		{ value: 10955, name: "Nidhi, Shipra" },
		{ value: 10987, name: "Kolangara, Bijoy" },
		{ value: 11188, name: "Tobon, Maria" },
		{ value: 12653, name: "Norton, Kevin" },
		{ value: 14536, name: "Haro, Armando" },
		{ value: 14939, name: "Venema, Caela" },
		{ value: 16289, name: "Cowan, Steve" },
		{ value: 17868, name: "Hall, Hannah" },
		{ value: 19984, name: "Howe, Krisy" },
		{ value: 21311, name: "Blackett, Kali" },
		{ value: 21710, name: "Bala, Janessa" },
		{ value: 22606, name: "Baugher, Alika" },
		{ value: 22607, name: "Ashlock, Malia" },
		{ value: 25414, name: "Melton, Jessica" },
		{ value: 29826, name: "Conroy, Joyce" },
		{ value: 35657, name: "Vega, Lisa" },
		{ value: 37302, name: "Support, Eapps" },
		{ value: 37500, name: "Dominguez, letti" },
		{ value: 43319, name: "Corniel, Kelcy" },
		{ value: 47303, name: "Ferrari, Alison" },
		{ value: 48452, name: "Finnegan, emily" },
		{ value: 48653, name: "Jones, Jen" },
		{ value: 51221, name: "Jones, Melissa" },
		{ value: 51224, name: "Taylor, Jacki" },
		{ value: 57298, name: "Winterhalter, Judy" },
		{ value: 57364, name: "Campbell, Rebecca" },
		{ value: 70305, name: "Dupaix, James" },
		{ value: 72678, name: "Teruya, Christina" },
		{ value: 78271, name: "Black, Jacki" },
		{ value: 83772, name: "Barnes, Lindsay" },
		{ value: 88305, name: "Galloway, Stephanie" },
		{ value: 88713, name: "Bright, Nainoa" },
		{ value: 91714, name: "Sumida, Dera" },
		{ value: 92137, name: "Malafu, Misti" },
		{ value: 97793, name: "Silva, Aldo" },
		{ value: 98831, name: "Akana, Janel" },
		{ value: 99563, name: "Garcia, Isabel" },
		{ value: 103925, name: "Kamaki, Herman" },
		{ value: 104921, name: "null, Jennifer" },
		{ value: 110054, name: "Vierra, Lorry" },
		{ value: 110810, name: "Chan, Mei" },
		{ value: 111374, name: "Koester, Berna" },
		{ value: 117053, name: "Scapecchi, Jordan" },
		{ value: 123530, name: "McCahill, Courtney" },
		{ value: 124564, name: "Murphy, Molly" },
	]

	quoteStatuses: any[] =
		[
			{ value: 'QR', name: 'Requested' },
			{ value: 'QS', name: 'Sent' },
			{ value: 'QC', name: 'Confirmed' },
			{ value: 'QE', name: 'Expired' },
			{ value: 'QX', name: 'Cancelled' },

		];

	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService
		) { }

	urlEndpoint = 'reservations';
	urlEndpoint1 = 'work-orders';

	reGenerateInvoice(data: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(data));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/regenerate-invoice`, data);
	}
	reGenerateOtaInvoice(reservationId: any): Observable<ApiResponse> {
		console.log('posting... ' + reservationId);
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/regenerate-ota-invoice/${reservationId}`);
	}

	addTravelAgentFee(data: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(data));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/add-travel-agent-fee`, data);
	}

	addWorkOrder(workOrder: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(workOrder));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint1}`, workOrder);
	}

	add(reservation: Reservation): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(reservation));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, reservation);
	}

	createReservation(data: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(data));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/add-admin-reservation`, data);
	}

	sendReviewEmailBeforeCheckout(reservation: Reservation): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(reservation));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/guest-exit-survey-before-checkout`, reservation);
	}

	sendReviewEmailAfterCheckout(reservation: Reservation): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(reservation));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/guest-exit-survey-after-checkout`, reservation);
	}

	hardDeleteOrder(orderId: number, force: boolean = false): Observable<ApiResponse> {
		const url = force
			? `${environment.apiUrl}/orders/${orderId}/hard-delete?force=true`
			: `${environment.apiUrl}/orders/${orderId}/hard-delete`;
		return this.http.delete<ApiResponse>(url);
	}
	sendReservationBalanceDueEmail(reservationId): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/send-reservation-balance-due-email/` + reservationId).pipe(retry({ count: 2, delay: 1500 }));
	}
	autoPayReservationBalance(reservationId): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/auto-pay-reservation-balance/` + reservationId).pipe(retry({ count: 2, delay: 1500 }));
	}
	update(reservation: Reservation): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, reservation);
	}
	updateWorkOrder(workOrder: any): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint1}`, workOrder);
	}

	updateGuestInfo(reservation: Reservation): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/guest-info`, reservation);
	}

	updateGuestInfoAutoUpdate(reservation: Reservation): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/guest-info-auto-update`, reservation);
	}

	delete(reservationId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${reservationId}`);
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	syncInvoice(reservationId: any): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/streamline/sync-invoice/${reservationId}`);
	}

	syncPayment(reservationId: any): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/streamline/sync-payment/${reservationId}`);
	}


	findByAgentListFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/agent-list`, { params: params })
	}

	findByAgentListFilterBalanceDue(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/balance-due/agent-list`, { params: params })
	}

	findByAgentListFilterInOutReport(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/reservation-in-out/agent-list`, { params: params })
	}

	findByReservationLedgerSummaryListFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		return this.http.get<ApiResponse>(`${environment.apiUrl}/reservation-ledger-summerys`, { params: params })
	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findMaintenanceEventByShortTermRentalIdAndanalyzeDate(shortTermRentalId: number, analyzeDate: any): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/maintenanceEvents/tap-chart/${shortTermRentalId}/${analyzeDate}`);
	}

	findReservationsByShortTermRentalId(shortTermRentalId: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/find-all-reservations/${shortTermRentalId}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findReservationsWith(queryString: string): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/reservations/find-with?query=${queryString}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	makeAdditionalPaymentByCreditCard(data: any) {
		console.log("createBooking POST: " + JSON.stringify(data));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/reservations/make-guest-addition-payment`, data);
	}

	makeAdditionalPaymentByAdmin(data: any) {
		console.log("createBooking POST: " + JSON.stringify(data));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/reservations/make-admin-addition-payment`, data);
	}

	makeVoidPaymentByAdmin(data: any) {
		console.log("createBooking POST: " + JSON.stringify(data));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/reservations/make-admin-void-payment`, data);
	}

	/**
	 * Admin reconcile-captured: tells the backend to verify a transaction with
	 * Authorize.net (capturedPendingSettlement / settledSuccessfully) and flip
	 * the corresponding payment_confirm row to (PC, A). Used after Sarah captures
	 * a stuck auth manually from the Authorize.net dashboard.
	 */
	markCapturedFromAuthnet(paymentConfirmId: number, authnetTxnId: string) {
		return this.http.post<ApiResponse>(
			`${environment.apiUrl}/payment/markCapturedFromAuthnet`,
			{ paymentConfirmId, authnetTxnId });
	}

  splitPayment(orderId: any, orderInvoiceDetailId: any) {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/order-invoice-details/split-invoice-details/${orderId}/${orderInvoiceDetailId}`);
  }

	search(propertyCode: string, locationId: number) {
		// return this.http.get<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }?name=${name}`).pipe(retry({ count: 2, delay: 1500 }));

		return this.http.get<any>(`${environment.apiUrl}/guest-portal/properties/location/find-by-location?propertyCode=${propertyCode}&locationId=${locationId}`)
			.toPromise()
			.then(res => <any>res.data)
			.then(data => { return data; });
	}

	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any) {

		let globalSearchFields = [
			{ field: 'reservationId', filter: 'contains' },
			{ field: 'orderId', filter: 'contains' },
			{ field: 'checkInDateTime', filter: 'contains' },
			{ field: 'guestProfileVO.lastName', filter: 'contains' },
			{ field: 'shortTermRentalVO.propertyCode', filter: 'contains' }
		];


		try {
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta) {
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++) {
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}

			if (globalFilter) {
				// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
				// params = params.append('filter', globalFilter);
				console.log('globalFilter: ' + JSON.stringify(globalFilter));
			}

			// multiselect or input or whatever... these work slick.
			if (filters) {
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++) {
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}

			console.log('FINAL FINDBY PARAMS ' + params);
			return params;
		} catch (error) {
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
	sendGuestCommunication(reservationId: number, stage: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/guest-portal/send-guest-comm/${reservationId}/${stage}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	getQuote(data: any) {
		console.log("getQuote POST: " + JSON.stringify(data));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/rate-quotes/generate-quote`, data);
	}
	getQuoteWithQuotedPrice(data: any) {
		console.log("getQuote POST: " + JSON.stringify(data));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/rate-quotes/custom-dynamic-quote`, data);
	}

	getOrderIdByReservationId(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/get-order-Id/${id}`).pipe();
	}

	findByOrderId(orderId: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/by-order-id/${orderId}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	getBedAvailability(reservationId: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${reservationId}/bed-availability`);
	}

	/**
	 * Generate Welcome Card PDF using reservation IDs
	 */
	generateWelcomeCard(reservationIds: number[]): Observable<Blob> {
		return this.http.post(`${environment.apiUrl}/pdf/welcomecard/generate`, { reservationIds }, {
			responseType: 'blob'
		});
	}

	generateWelcomeCardWithFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<Blob> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, 500, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		return this.http.get(`${environment.apiUrl}/pdf/welcomecard/generate/with-filter`, {
			params: params,
			responseType: 'blob'
		});
	}
}
